import {
    Component,
    OnInit,
    ViewChild,
    EventEmitter,
    Output,
    Input,
} from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { HelperService } from "../../services/helper.service";
import { MapDesignationService } from "../../services/mapdesignation.service";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";

import { AssessmentService } from "../../services/assessment.service";
import { ObjectivesService } from "../../services/objectives.service";


@Component({
    selector: "app-objectives-edit-modal-desig-edit",
    templateUrl: "./objectives-edit-modal-desig-edit.html",
    providers: [ObjectivesService],
})


export class EditMapDesigModalComponent implements OnInit {

    @Input() auto_id: number;
    validateForm: FormGroup;
    DesList: any = {
        desigid: "",
        designation: "",
      };


    @Output() dataToEmit: EventEmitter<any> = new EventEmitter<any>();
    @Output() tableReload: EventEmitter<any> = new EventEmitter();
    @ViewChild("swalModal") swalModal: any;
    @ViewChild("errorMessageHtml") errorMessageHtml: any;
    @ViewChild("swalModalUpdateMapDesig") swalModalUpdateMapDesig: any;

    public successMsg: string = "";
    public htmlErrorMessage: string = "";
    companySystemID = +this.helperService.getSelectedCompanyId();
    Designations: any = [];

    constructor(
        private formBuilder: FormBuilder,
        public bsModalRef: BsModalRef,
        private helperService: HelperService,
        private modalService: BsModalService,
        private route: ActivatedRoute,
        private spinner: NgxSpinnerService,
        private objectivesService: ObjectivesService,
        private assessmentService: AssessmentService,
    ) { }


    showErrorHtml() {
        setTimeout(() => {
            this.errorMessageHtml.show();
        }, 0);
    }

    closeModal() {
        this.bsModalRef.hide();
        this.modalService.setDismissReason("");
    }

    closeModalAfterCreate() {
        this.bsModalRef.hide();
        this.modalService.setDismissReason("");
    }

    showSuccessHtml() {
        setTimeout(() => {
            this.swalModal.show();
        }, 0);
    }



    ngOnInit() {
        this.auto_id = Number(localStorage.getItem("objective-select-edit-auto_id"));
        localStorage.removeItem("objective-select-edit-auto_id");
        console.log(this.auto_id);

        this.validateForm = this.formBuilder.group({
            desigid: [{ value: "" }, [Validators.required]],
            designation: [{ value: "" }, [Validators.required]],
        });
        console.log(this.validateForm);

        this.getEditMapDesig(this.auto_id);
        this.retrieveDesignations();
    }


    getEditMapDesig(auto_id: number) {
        console.log(this.auto_id);
        this.objectivesService
          .getEditMapDesig(this.auto_id)
          .get()
          .subscribe((resp) => {
            const data = resp.data.data;
            console.log(data);
            this.DesList = data;
          });
      }


    updateMapDesig() {
        console.log(this.auto_id);

        const designSelect = this.DesList.designation;
        const [designationCategory, id] = designSelect.split('-');


        const requestData = {
            desigid: id,
            designation: designationCategory,
            auto_id: this.auto_id,
        };
        console.log(requestData);
        let that = this;
        this.objectivesService
            .updateMapDesig(this.auto_id)
            .customPUT(requestData)
            .subscribe(
                (resp: any) => {
                    console.log(resp);
                    this.successMsg = "Successfully updated map designation";
                    this.swalModalUpdateMapDesig.show();
                    this.tableReload.emit();
                },
                (error) => {
                    that.htmlErrorMessage = "";
                    if (error.status == 500) {
                        that.htmlErrorMessage = error.data.message;
                        that.showErrorHtml();
                    } else if (error.status == 422) {
                        that.htmlErrorMessage = that.helperService.serverSideError422(
                            error.data.message
                        );
                        that.showErrorHtml();
                    }
                    this.tableReload.emit();
                }
            );
        this.tableReload.emit();
    }







    retrieveDesignations(): void {
        this.Designations = [];
        let dataTablesParameters: any = {
            companyId: this.helperService.getSelectedCompanyId(),
        };
        this.assessmentService
            .retrieveDesignations()
            .customPOST(dataTablesParameters)
            .subscribe(
                (resp: any) => {
                    let data = JSON.parse(resp._body);
                    this.Designations = data.data;
                    console.log(this.Designations);
                },
                (err: any) => {
                    console.log(err);
                }
            );
    }

    selectedDesignation: string;
    onDesignationChange(event) {
        this.selectedDesignation = event.target.value.split('-')[1];
    }


}



// WEBPACK FOOTER //
// /app/src/app/competancy/objectives-edit-modal-desig-edit/objectives-edit-modal-desig-edit.ts